import React, { useEffect, useState, useCallback, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';

import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box, Card, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { useStore } from 'src/store/store';
import { NavLink } from 'react-router-dom';
import ViewIcon from '@material-ui/icons/Visibility';
import DeleteIcon from '@material-ui/icons/Delete';
import TablePagination from '@material-ui/core/TablePagination';
import config from '../../../config/config';
import ConfirmDialog from '../../../components/dialog/ConfirmDialog';

const BookList = observer(() => {
  const { crawledBook } = useStore();
  const { books, total, page } = crawledBook;
  useEffect(() => {
    crawledBook.fetchBooks();
  }, [crawledBook]);

  const handlePageChange = (_, newPage) => {
    crawledBook.changePage(newPage + 1);
  };
  const [openDialogDelete, setOpenDialogDelete] = useState(false);
  const deletingBookIdRef = useRef(null);

  const handleDeleteClick = id => {
    deletingBookIdRef.current = id;
    setOpenDialogDelete(true);
  };

  const handleCancelDelete = () => {
    setOpenDialogDelete(false);
  };
  const handleSubmitDelete = useCallback(() => {
    crawledBook.deleteBook(deletingBookIdRef.current);
    setOpenDialogDelete(false);
  }, [crawledBook]);

  return (
    <Box mt={3}>
      <Card>
        <PerfectScrollbar>
          <Box minWidth={300}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Author</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {books.map(bookItem => {
                  return (
                    <>
                      <TableRow key={`cat ${bookItem.id}`}>
                        <TableCell>{bookItem.name}</TableCell>
                        {bookItem.category.parent !== null ? (
                          <TableCell>{`${bookItem.category.parent.name} > ${bookItem.category.name}`}</TableCell>
                        ) : (
                          <TableCell>{bookItem.category.name}</TableCell>
                        )}
                        {bookItem.author !== null ? (
                          <TableCell>{bookItem.authorName}</TableCell>
                        ) : (
                          <TableCell />
                        )}
                        <TableCell align="right">
                          <IconButton
                            component={NavLink}
                            to={`/app/crawledBooks/edit/${bookItem.id}`}
                          >
                            <ViewIcon size="small" />
                          </IconButton>
                          <IconButton>
                            <DeleteIcon
                              size="small"
                              onClick={() => handleDeleteClick(bookItem.id)}
                            />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    </>
                  );
                })}
              </TableBody>
            </Table>
          </Box>
        </PerfectScrollbar>
        <TablePagination
          component="div"
          count={total}
          rowsPerPageOptions={[]}
          page={page - 1}
          onChangePage={handlePageChange}
          rowsPerPage={config.itemsPerPage}
        />
      </Card>
      <ConfirmDialog
        title="Delete Confirmation"
        message="Are you sure want to delete Book?"
        open={openDialogDelete}
        onClose={handleCancelDelete}
        onOk={handleSubmitDelete}
      />
    </Box>
  );
});

BookList.propTypes = {
  className: PropTypes.string,
  customers: PropTypes.array.isRequired,
};

export default BookList;
